import {initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';

const config = {
  apiKey: 'AIzaSyCd-KiDZgeWuT1UifFfcvq2-KNF3d9DL3g',
  authDomain: 'revoplas-4b8af.firebaseapp.com',
  projectId: 'revoplas-4b8af',
  storageBucket: 'revoplas-4b8af.appspot.com',
  messagingSenderId: '920149297420',
  appId: '1:920149297420:web:00c93340ba1eec437f2129'
};

const app = initializeApp(config);

const auth = getAuth(app);
const firestore = getFirestore(app);

export {auth, firestore};
